import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Text from '../Text';
import Styles from './InputsField.styles';
import { WHITE } from '../../../constants/colors';

const Wrapper = styled.div`${Styles.wrapper}`; // prettier-ignore
const LabelTop = styled(Text)`${Styles.labelTop}`; // prettier-ignore
const Label = styled(Text).attrs({ bold: true })`${Styles.label}`; // prettier-ignore
const LabelWarn = styled(Text)`${Styles.label}`; // prettier-ignore
const Input = styled.input`${Styles.input}`; // prettier-ignore

/**
 * Inputs field component
 * @param {Object} param - props
 * @returns {JSX}
 */
const InputsFieldFlat = ({
  type,
  label,
  labelWarn,
  labelOnTop,
  className,
  placeHolder,
  reference,
  value,
  onChange,
  name,
  status,
  fixAutofill,
  disableAutocomplete,
  autoComplete,
  isRequired,
  onPaste,
  ...props
}) => {
  return (
    <Wrapper className={className} fixAutofill={fixAutofill}>
      {labelOnTop && <LabelTop status={status}>{label}</LabelTop>}
      <Input
        {...props}
        status={status}
        type={type}
        placeholder={placeHolder}
        innerRef={reference}
        value={value}
        name={name}
        onChange={onChange}
        autoComplete={disableAutocomplete ? 'off' : autoComplete}
        required={isRequired}
        onPaste={onPaste}
      />
      {!labelOnTop && <Label status={status}>{label}</Label>}
      {labelOnTop && status === 2 && (
        <LabelWarn
          status={status}
          style={{
            marginTop: '-0.75rem',
            marginBottom: '0.25rem',
            color: '#DC3545',
            padding: 0,
            font: '12.8px Arial, sans-serif'
          }}
        >
          {labelWarn}
        </LabelWarn>
      )}
    </Wrapper>
  );
};

InputsFieldFlat.propTypes = {
  type: PropTypes.string,
  label: PropTypes.string,
  className: PropTypes.string,
  value: PropTypes.string,
  placeHolder: PropTypes.string,
  onChange: PropTypes.func,
  reference: PropTypes.object,
  name: PropTypes.string,
  status: PropTypes.number,
  fixAutofill: PropTypes.string,
  disableAutocomplete: PropTypes.bool,
  autoComplete: PropTypes.string,
  isRequired: PropTypes.bool
};

InputsFieldFlat.defaultProps = {
  type: 'text',
  fixAutofill: WHITE,
  autoComplete: 'on',
};

export default InputsFieldFlat;
